import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let Footer = class Footer extends Vue {
};
tslib_1.__decorate([
    Prop(Boolean)
], Footer.prototype, "aboutDisplay", void 0);
Footer = tslib_1.__decorate([
    Component({
        name: 'Footer'
    })
], Footer);
export default Footer;
